module.exports = __webpack_public_path__ + "img/marker_green.01b6669c.svg";